<script>
import HeaderTopbar from 'components/common/HeaderTopbar'

export default {
  name: 'AboutUs',
  components: { HeaderTopbar }
}
</script>

<template lang="pug">
section.about-us.dm-corp-page
  header-topbar(active-item="about")

  .main-container
    article.page-main
      header.page-header
        h1 格米科技，数据驱动的智能心理服务平台
      section.content-container
        p 
          b 感谢您关注DiggMind！
        p DiggMind隶属于广州市格米网络科技有限公司，我们是一个<b>数据驱动的智能心理服务平台</b>。
        p 我们致力于心理数据的分析研究，并为多种多样心理服务的智能化实现、提供基于数据科学的新方法。我们尽可能地借助前沿的计算机和互联网技术开展以上工作。
        p 基于DiggMind智能心理云平台，我们能够为个人用户和企业用户提供高效便捷的服务。迄今为止，已有<b>超过500万人次</b>的个人及企业付费用户使用DiggMind。
        p DiggMind的使命是，提供有温度的智能心理服务，<b>在大数据时代引领心理应用的升级转型</b>，让每位用户都能享受到心理科学带来的美好价值。
        p.dimmed 创始人、CEO 郭永兴先生，是华南师范大学心理学博士、组织行为学与用户研究专家、心理学报审稿人。具有超过 20年的心理测量与心理数据分析经验，主持、参与100+企业心理评估项目。历任蓝心网、博曼心理、艾思林柯、壹心理的联合创始人、合伙人、测评总监等职务。
</template>

<style lang="scss">
@import "../styles/variables";

section.about-us.dm-corp-page {
  background: $bg-lighter-gray;
  padding: 30px 0 50px 0;

  .page-main {
    max-width: 800px;
    margin: 0 auto;

    border-radius: 12px;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 3px 10px black(0.05);
  }

  header.page-header {
    @include bgImage;
    background-size: cover;
    background-image: url(../assets/images/about-us-header.png);
    height: 400px;
    position: relative;

    h1 {
      position: absolute;
      width: 90%;
      bottom: -1.2em;
      left: 50%;
      font-size: 22px;
      line-height: 130%;
      text-align: center;
      background: $primary-color;
      border-radius: 6px;
      color: #fff;
      padding: 0.6em 1em;
      transform: translate3d(-50%, 0, 0);
    }
  }

  .content-container {
    padding: 70px 60px;

    p {
      line-height: 160%;
      margin-top: 1.8em;
      padding: 0;
      text-align: left;

      b {
        color: $text-dark;
        font-weight: 800;
      }

      &.dimmed {
        color: $text-gray;
        font-size: 0.9em;
        border-top: 1px dotted black(0.15);
        padding-top: 2em;
        margin-top: 3em;
      }

      &:first-of-type {
        margin-top: 0;
      }
    }
  }
}
</style>